/********************************************************
* Landing Page / Login View Module
*
* please add description of module here
*
********************************************************/



/**********************************************
 DEPENDENCIES
**********************************************/
var $ = require('jquery');
var auth = require('Modules/auth');
var api = require('Modules/api');
var Ractive = require('ractive');
var template = require('Templates/landing_page.html');
window.ds = require('Modules/data_store');

/**********************************************
 Variable Declarations
**********************************************/
var lp = {};
var login_complete_cb;
window.view;




/**********************************************
 HELPER Functions
**********************************************/

var add_p_tags = function(str) {
	return str
        .replace(/\r\n?/g,'\n')
        // normalize newlines - I'm not sure how these
        // are parsed in PC's. In Mac's they're \n's
        .replace(/(^((?!\n)\s)+|((?!\n)\s)+$)/gm,'')
        // trim each line
        .replace(/(?!\n)\s+/g,' ')
        // reduce multiple spaces to 2 (like in "a    b")
        .replace(/^\n+|\n+$/g,'')
        // trim the whole string
        .replace(/[<>&"']/g,function(a) {
        // replace these signs with encoded versions
            switch (a) {
                case '<'    : return '&lt;';
                case '>'    : return '&gt;';
                case '&'    : return '&amp;';
                case '"'    : return '&quot;';
                case '\''   : return '&apos;';
            }
        })
        .replace(/\n{2,}/g,'</p><p>')
        // replace 2 or more consecutive empty lines with these
        .replace(/\n/g,'<br />')
        // replace single newline symbols with the <br /> entity
        .replace(/^(.+?)$/,'<p>$1</p>');
        // wrap all the string into <p> tags
        // if there's at least 1 non-empty character
}


/**********************************************
 Private Functions
**********************************************/


var login_try = function(data) {

	// can we log in?
	auth.login( 'POST', '/api/app/auth/login', data )
        .done( function(data) { 
            if (data.success) {
            	console.log('login success');
            	api.set_header('Authorization', ds.get('token'));

                // does user have existing config data for this unit?
                //var payload = ds.get('token_payload');
                var payload = data.user;

                // check for user data
                api.get_user_data( payload['id'], view.get('unit_id') )
                	.done( function(data) {

                		if (data.data != null) {
                			console.log('HAVE DATA');

                			// save data and request if use or clear it
                			ds.ds_set('config', data.data);
                			dom_touch.state_continue();
                		}
                		else {
                			console.log('NO DATA');
                			if (login_complete_cb) login_complete_cb();
                		}
                	});
            }
            else {
            	// new user
            	console.log('login fail');
    			dom_touch.state_moreinfo();
            }
        });
}



var dom_events = {

	login_listeners : function() {

		$('#form_login_submit').off().on('click', function(e) {
			e.preventDefault();
            var $form = $("#login_form");

            if (view.get('form_data.username') != '') login_try( $form.serialize() );
            else {
            	console.log('no value entered');
            	$('#login_form .form_error').removeClass('form_error_hidden');
            }
		})
	},

	moreinfo_listeners : function() {
		$('#form_moreinfo_submit, #form_moreinfo_skip').off().on('click', function(e) {
			e.preventDefault();

			// retrieve form data
			api.create_user( view.get('form_data') )
				.done( function(data) {
					if (data.success) login_try( view.get('form_data') );
					else alert('failed to log in, please refresh page and try again.');
				});
		});
	},

	continue_listeners : function() {

		// listen to input to move on with current stored config data
		$('#form_continue_yes').off().on('click', function(e) {
			e.preventDefault();
			console.log('keep it');
			console.log( ds.ds_get('config') );

			// indicate login complete and that we want to use recieved config data which is now in data_store
			if (login_complete_cb) login_complete_cb();
		});

		// listen to input to clear config data
		$('#form_continue_no').off().on('click', function(e) {
			e.preventDefault();
			console.log('clear it');

			// clear config data that is in data_store for this unit
			ds.ds_remove('config');

			// indicate login complete and that we can move to configurator
			if (login_complete_cb) login_complete_cb();
		})
	}
}



var dom_touch = {

	state_login : function() {
		$('.state--list').removeClass('state--list').addClass('state--login');
	},


	state_moreinfo : function() {
		$('.state--login').removeClass('state--login').addClass('state--moreinfo');
		dom_events.moreinfo_listeners();
	},


	state_continue : function() {
		$('.state--moreinfo, .state--login').removeClass('state--moreinfo').removeClass('state--login').addClass('state--continue');
		dom_events.continue_listeners();
	}
}



/**********************************************
 Public Functions
**********************************************/

// public method to have community landing page displayed
lp.show_lp = function(data, ready_cb) {
	data.add_p_tags = add_p_tags;

	// create view from template and pass data
	view = new Ractive({
		el : "#container",
		template: template,
		data : data
	});

	if (ready_cb) ready_cb();
}


// public method to have login screen displayed
lp.show_login = function(data, ready_cb) {
	
	// check if direct visit to unit url or via landing page
	if (data.init) {
		

		// create view from template and pass data
		view = new Ractive({
			el : "#container",
			template: template,
			data : data
		});

		if (ready_cb) ready_cb();
	}
	else {
		// template already active since visit via landing page, so change state of template
		view.set('unit_id', data.unit_id);
		dom_touch.state_login();
	}

	// activate listener for login form
	dom_events.login_listeners();
}


// public method to define callback function when login complete
lp.login_complete = function(callback) {
	login_complete_cb = callback;
}



/**********************************************
 Module Export
**********************************************/
module.exports = lp;